import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Button } from '@rsos/base-components';
import { dismissAllToasts } from '@rsos/utils/toastUtils';
import { StyledToastContainer } from './index.styles';

const ClearAllButtonWrapper = styled.div`
  position: fixed;
  top: 1rem;
  left: calc(50% + 335px);
  z-index: 99999;

  @media (max-width: 1024px) {
    left: calc(50% + 250px);
  }
`;

const ClearAllButton = styled(Button)`
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  white-space: nowrap;
`;

export const ToastContainerWithClearAll = ({ ...props }) => {
  const [toastCount, setToastCount] = useState(0);

  useEffect(() => {
    const checkToasts = () => {
      const toastElements = document.querySelectorAll('.Toastify__toast');
      setToastCount(toastElements.length);
    };

    const observer = new MutationObserver(checkToasts);

    const tryObserve = () => {
      const container = document.querySelector('.Toastify');
      if (container) {
        observer.observe(container, {
          childList: true,
          subtree: true,
        });
        checkToasts();
        return true;
      }
      return false;
    };

    if (!tryObserve()) {
      const interval = setInterval(() => {
        if (tryObserve()) {
          clearInterval(interval);
        }
      }, 100);

      return () => {
        clearInterval(interval);
        observer.disconnect();
      };
    }

    return () => observer.disconnect();
  }, []);

  const handleClearAll = () => {
    dismissAllToasts();
  };

  return (
    <>
      {toastCount >= 3 && (
        <ClearAllButtonWrapper>
          <ClearAllButton
            onClick={handleClearAll}
            size="small"
            variant="secondary"
            data-name="clear-all-toasts-button"
          >
            Clear All
          </ClearAllButton>
        </ClearAllButtonWrapper>
      )}
      <StyledToastContainer {...props} />
    </>
  );
};

export default ToastContainerWithClearAll;
